

import { Tabs } from 'antd';


export default function TabPanel({ tabInfo }) {
    const { TabPane } = Tabs;

    return (
        <Tabs defaultActiveKey="1" destroyInactiveTabPane>
            {tabInfo.map((info) =>
                <TabPane tab={info.tab} key={info.key}>
                    {info.component}
                </TabPane>
            )}
        </Tabs>
    )
}


